import React from 'react'
import { Link } from 'react-router-dom';

const ButtonGroup = () => {
    return (
        <>
            <div className='mb-3 border-t-sky-500 border-t-4 bg-white w-full'>
                <div className="w-full py-4 md:py-0 px-4 text-sm pt-3 bg-white">
                    <div className=" w-full">
                        <div className='flex justify-center gap-3 items-center flex-wrap py-4'>

                            <select className="form-select form-select-sm h-10  w-48 px-2 py-1 pr-10 text-sm font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat appearance-none
                                            border border-solid border-black
                                            rounded transition ease-in-out m-0
                                            focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" aria-label=".form-select-sm example">
                                <option value=''>Select Branch</option>
                                <option value="1">One</option>
                                <option value="2">Two</option>
                                <option value="3">Three</option>
                            </select>

                            <input type="date" name='date' className='px-2 py-1 h-10 w-48 text-sm font-normal text-gray-700
                            border border-solid border-black rounded focus:text-gray-700 focus:border-blue-600 focus:outline-none'/>

                            <Link to="/"><button className='first_button bg-blue-800 hover:bg-blue-900'>Show Details</button></Link>
                            <Link to="/admin/enquiry/"> <button className='first_button bg-orange-500 hover:bg-orange-600'> Add Enquary</button></Link>
                            <Link to="/admin/members/"> <button className='first_button bg-orange-500 hover:bg-orange-600'> Add Member</button></Link>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ButtonGroup